<template>
  <div
    class="form-group "
    :class="{
      'required': required,
      'input-group-focus': focused,
      'has-danger': error,
      'has-success': !error && touched,
      'has-label': label,
      'has-icon': hasIcon,
      
    }"
  >
    <slot name="label">
      <label v-if="label"> {{ label }} {{ required ? '*' : '' }} </label>
    </slot>
    <div class="mb-0" :class="{'input-group': hasIcon}">
      <slot name="addonLeft">
        <span v-if="addonLeftIcon" class="input-group-prepend">
          <div class="input-group-text"><i :class="addonLeftIcon"></i></div>
        </span>
      </slot>
      <slot>
        <!--
        <input v-if="mask=='phone'"
          :value="value"
          v-bind="$attrs"
          v-on="listeners"
          class="form-control"
          aria-describedby="addon-right addon-left"
          v-cleave="{phone: true, phoneRegionCode : 'RU', prefix: '+', noImmediatePrefix: true}"
        />
        -->
        
        <input v-if="mask=='phone'"
          :value="value"
          v-bind="$attrs"
          v-on="listeners"
          class="form-control"
          aria-describedby="addon-right addon-left"
          v-phone
        />
        
        <input v-else
          :value="value"
          v-bind="$attrs"
          v-on="listeners"
          class="form-control"
          aria-describedby="addon-right addon-left"
        />
      </slot>
      <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-append">
          <div class="input-group-text"><i :class="addonRightIcon"></i></div>
        </span>
      </slot>
    </div>

    <slot name="error" v-if="error || $slots.error">
      <label class="error">{{ error }}</label>
    </slot>
    <slot name="helperText"></slot>
  </div>
</template>
<script>
/*
import Cleave from 'cleave.js';
import cleavePhoneI18n from 'cleave.js/dist/addons/cleave-phone.i18n';
*/

  const replaceNumberForInput=function(value) {
    let val = '';
    
    const startFrom = 7; // С какой цифры начинается номер
    let plus = '+';
    let digit = '7';

    if (startFrom === 8) {
      plus = '';
      digit = '8';
    } else {
      plus = '+';
      digit = '7';
    } 

    // console.log(value);
    //const x = value.replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
    // const x = value.replace(/[\s()-]+/gi, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
    const x = value.replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
    //console.log(x);

    if (!x[2] && x[1] !== '') {
      if(x[1]==='8') x[1] = '7';
      val = x[1] === digit ? plus + x[1] : plus + digit + x[1];
    } else {
      if(x[1]==='8') x[1] = '7';
      val = plus + (!x[3] ? x[1] + x[2] : x[1] + '(' + x[2] + ')' + x[3] + (x[4] ? '-' + x[4] : '') + (x[5] ? '-' + x[5] : ''));
    }
    return val;
  }


export default {
  inheritAttrs: false,
  name: 'base-input',
  props: {
    required:{
				type: Boolean,
				default: false
			},
    mask: {
      type: String,
      description: 'Input mask',
      default: ''
    },
    label: {
      type: String,
      description: 'Input label'
    },
    error: {
      type: String,
      description: 'Input error',
      default: ''
    },
    value: {
      type: [String, Number],
      description: 'Input value'
    },
    addonRightIcon: {
      type: String,
      description: 'Input icon on the right'
    },
    addonLeftIcon: {
      type: String,
      description: 'Input icon on the left'
    },
    ruContact: {
      type: Boolean,
      description: 'Input type',
      
    },
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data() {
    return {
      focused: false,
      touched: false,
    };
  },
  computed: {
    hasIcon() {
      return this.hasLeftAddon || this.hasRightAddon
    },
    hasLeftAddon() {
      const { addonLeft } = this.$slots;
      return (
        addonLeft !== undefined ||
        this.addonLeftIcon !== undefined
      );
    },
    hasRightAddon() {
      const { addonRight } = this.$slots;
      return (
        addonRight !== undefined ||
        this.addonRightIcon !== undefined
      );
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: this.onBlur,
        focus: this.onFocus
      };
    }
  },
  methods: {
    onInput(evt) {
      if (!this.touched) {
        this.touched = true;
      }
      this.$emit('input', evt.target.value);
    },
    onFocus(evt) {
      this.focused = true;
      this.$emit('focus', evt)
    },
    onBlur(evt) {
      this.focused = false;
      this.$emit('blur', evt)
    }
  },
  directives: {
        /*
        cleave: {
            inserted: (el, binding) => {
                el.cleave = new Cleave(el, binding.value || {})
            },
            update: (el) => {
                const event = new Event('input', {bubbles: true});
                setTimeout(function () {
                    el.value = el.cleave.properties.result
                    el.dispatchEvent(event)
                }, 100);
            }
        },
        */
        phone:{
          bind(el) { 
              el.oninput = function(e) {
                if (!e.isTrusted) {
                  return;
                }
                if((this.value.startsWith('+7') || this.value.startsWith('8')) && !this.value.startsWith('+77')){
                  // +77 -- Казахстан
                  this.value = replaceNumberForInput(this.value); this.ruContact = true;
                } else {this.value = this.value; this.ruContact = false; /*this.error = '';*/}
                // this.value = replaceNumberForInput(this.value);
                
              }
              
              el.onpaste = function() {
                setTimeout(() => {
                  if((this.value.startsWith('+7') || this.value.startsWith('8')) && !this.value.startsWith('+77')){
                    this.value = replaceNumberForInput(this.value); this.ruContact = true;
                  } else {this.value = this.value; this.ruContact = false; /*this.error = '';*/}
                  // this.value = replaceNumberForInput(this.value);
                })
              }
          },
          update: (el) => {
                const event = new Event('input', {bubbles: true});
                setTimeout(() => {
                  let tmp = replaceNumberForInput(el.value);
                  if(tmp !== el.value){
                    el.value = tmp
                    el.dispatchEvent(event)
                  }
                }, 100);
          }
        }
  }
};
</script>
<style></style>
